import { login } from 'data/user';
import React, { useEffect, useState } from 'react';
import {
  TextInput,
  Text,
  View,
  StyleSheet,
  Pressable,
  Image,
} from 'react-native';
import { useNavigate } from 'react-router-dom';

const loadingIcon = require('assets/loading.gif');

export function Login() {
  const navigate = useNavigate();
  const [loginData, setLoginData] = useState({
    username: '',
    password: '',
  });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [formIsValid, setFormIsValid] = useState(false);

  function onChangeText(val, key) {
    setLoginData({ ...loginData, [key]: val });
  }

  function submit() {
    setError(null);
    setLoading(true);
    login(loginData.username, loginData.password)
      .then(() => {
        return navigate('/admin');
      })
      .catch((err) => {
        setLoading(false);
        if (err === 'Incorrect login') {
          setError('Incorrect login, please try again.');
        } else {
          setError('An error has occurred, please try again later.');
        }
      });
  }

  function handlePress(event) {
    if (event.key === 'Enter') {
      submit();
    }
  }

  useEffect(() => {
    const isValid = loginData.username && loginData.password ? true : false;
    setFormIsValid(isValid);
  }, [loginData]);

  return (
    <View style={style.container}>
      <View>
        <Text style={style.title}>Welcome! Please log in</Text>
        <View>
          <Text style={style.label}>User name:</Text>
          <TextInput
            onChangeText={(val) => onChangeText(val, 'username')}
            style={style.input}
            value={loginData.username}
            onKeyPress={handlePress}
          />

          <Text style={style.label}>Password:</Text>
          <TextInput
            onChangeText={(val) => onChangeText(val, 'password')}
            style={style.input}
            value={loginData.password}
            secureTextEntry={true}
            onKeyPress={handlePress}
          />

          {error && <Text style={style.error}>{error}</Text>}

          {loading ? (
            <Pressable style={[style.button, style.disabled]}>
              <Image source={loadingIcon} style={style.loadingImage} />
            </Pressable>
          ) : (
            <Pressable
              onPress={submit}
              style={[style.button, !formIsValid ? style.disabled : null]}
              disabled={!formIsValid}
            >
              <Text style={style.buttonText}>Login</Text>
            </Pressable>
          )}
        </View>
      </View>
    </View>
  );
}

const style = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    padding: 20,
  },
  title: {
    fontSize: 24,
    marginBottom: 20,
    fontWeight: 'bold',
  },
  input: {
    borderWidth: 1,
    borderColor: 'grey',
    padding: 5,
    borderRadius: 0,
    marginBottom: 10,
  },
  success: {
    color: '#008000',
  },
  error: {
    color: '#e43333',
    fontWeight: 'bold',
    marginBottom: 10,
    fontSize: 18,
  },
  inputError: {
    borderColor: '#e43333',
    marginBottom: 0,
  },
  label: {
    fontSize: 18,
    marginBottom: 5,
  },
  button: {
    backgroundColor: '#152B61',
    alignSelf: 'flex-start',
    padding: 5,
  },
  buttonText: {
    color: '#fff',
    fontWeight: 'bold',
    padding: 5,
    fontSize: 16,
  },
  loadingImage: {
    width: 30,
    height: 30,
  },
  disabled: {
    opacity: 0.5,
  },
});
